export var addStyleIfPropTruly = function addStyleIfPropTruly(propName, style) {
  return function (props) {
    if (props[propName]) {
      return "".concat(style);
    }
  };
};
export var addStyle = function addStyle(propName, value) {
  return "".concat(propName, ": ").concat(value, ";");
};